export default __webpack_public_path__ + "static/Cafe24Danjunghae.subset-bfdf37acbd784dee25d5319f24b95a95.woff2";